import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./EnergyShop.module.scss";
import p1 from "../../../assets/images/current.png";
import { useDispatch, useSelector } from "react-redux";
import {
    getPurchaseLink,
    checkPaymentStatus,
    getUserProfile,
    cancelPayment,
    updateProfile
} from "../../../lib/store/actions";
import { useTonConnectUI } from '@tonconnect/ui-react';
import { showToast } from "../../../helper/common";
import VerifyingPaymentLoader from "../../Loader/verifyPayment";
import tokenIcn from "../../../assets/images/usdt-ton.png"
import CustomLoader from "../../Loader/index";
import { getUsdtWalletAddress, getNetworkName, usePreventTonModalClose } from '../../../helper/common';
const GAS_FEE = '50000000';

const EnergyShop = ({ showEnergyPackage, setShowEnergyPackage, packageItem }) => {
    usePreventTonModalClose();
    const [loading, setLoading] = useState(false);
    const [tonConnectUI] = useTonConnectUI();
    const [verify, setVerify] = useState(false);

    const dispatch = useDispatch();
    const { settingsData, userData } =
        useSelector(({ Settings, Auth }) => ({
            userData: Auth.user,
            settingsData: Settings.settings
        }));


    const handlePurchase = async (packageId, energy) => {
        if (verify) {
            showToast("Please wait for previous transaction completion", "error");
        }
        if (settingsData?.energy?.maxEnergyBalance < (userData.energyBalance + energy)) {
            showToast('Purchase not allowed—exceeds max energy limit.', 'info');
            return;
        }
        console.log("wallet connected ====>", tonConnectUI?.connected);

        if (tonConnectUI && !tonConnectUI?.connected) {
            await tonConnectUI.connectWallet();
            if (tonConnectUI?.account) {
                const networkName = getNetworkName(tonConnectUI?.account?.chain);
                const targetNetwork = settingsData?.payment?.tonNetwork;
                if (networkName !== targetNetwork) {
                    showToast(`Please switch your wallet network manually to ${targetNetwork} and reconnect!`, "error");
                    return;
                }
            }
            setLoading(true);
            dispatch(
                updateProfile({
                    data: { _id: userData?._id, walletAddress: tonConnectUI?.account?.address },
                    callBack: (err, data) => {
                        if (err) {
                            setLoading(false);
                            return;
                        }
                        dispatch(getPurchaseLink({
                            data: {
                                quantity: 1,
                                energyPackageId: packageId
                            },
                            callBack: async (err, res) => {
                                if (err) {
                                    setLoading(false);
                                    showToast("Network Error! Please try later.", "error");
                                    return;
                                }
                                setLoading(!loading);
                                const { purchaseID, payload } = res.data;
                                if (tonConnectUI?.connected) {
                                    const userTonAddress = tonConnectUI?.account?.address;
                                    const userUSDTAddress = await getUsdtWalletAddress(userTonAddress, settingsData);
                                    if (userUSDTAddress) {
                                        try {
                                            await tonConnectUI.sendTransaction({
                                                validUntil: Math.floor(Date.now() / 1000) + 300,
                                                // network: settingsData?.payment?.tonNetwork,
                                                messages: [
                                                    {
                                                        address: userUSDTAddress || userTonAddress,
                                                        amount: GAS_FEE,
                                                        payload: payload
                                                    }
                                                ]
                                            });

                                            setLoading(false);
                                            setVerify(true);
                                            await verifyPayment(purchaseID);
                                        }
                                        catch (error) {
                                            console.log("Transaction was rejected or cancelled by the user");
                                            setLoading(false);
                                            setVerify(false);
                                            showToast("Transaction was cancelled!", "error");
                                        }
                                    }
                                    else {
                                        showToast("USDT Wallet not found!", "error");
                                        setLoading(false);
                                        setVerify(false);
                                        hidePopup();
                                    }
                                }
                            }
                        }));
                    },
                })
            )
        }
        else if (tonConnectUI?.connected) {
            if (tonConnectUI?.account) {
                const networkName = getNetworkName(tonConnectUI?.account?.chain);
                const targetNetwork = settingsData?.payment?.tonNetwork;
                if (networkName !== targetNetwork) {
                    showToast(`Please switch your wallet network manually to ${targetNetwork}`, "error");
                    return;
                }
            }
            setLoading(!loading);
            dispatch(getPurchaseLink({
                data: {
                    quantity: 1,
                    energyPackageId: packageId
                },
                callBack: async (err, res) => {
                    if (err) {
                        setLoading(false);
                        showToast("Network Error! Please try later.", "error");
                        return;
                    }
                    setLoading(!loading);
                    const { purchaseID, payload } = res.data;
                    if (tonConnectUI?.connected) {
                        const userTonAddress = tonConnectUI?.account?.address;
                        const userUSDTAddress = await getUsdtWalletAddress(userTonAddress, settingsData);
                        try {
                            await tonConnectUI.sendTransaction({
                                validUntil: Math.floor(Date.now() / 1000) + 300,
                                // network: settingsData?.payment?.tonNetwork,
                                messages: [
                                    {
                                        address: userUSDTAddress || userTonAddress,
                                        amount: GAS_FEE,
                                        payload: payload
                                    }
                                ]
                            });
                            setLoading(false);
                            setVerify(true);
                            await verifyPayment(purchaseID);
                        }
                        catch (error) {
                            console.log("Transaction was rejected or cancelled by the user");
                            setLoading(false);
                            setVerify(false);
                            showToast("Transaction was cancelled!", "error");
                            dispatch(cancelPayment({
                                data: {
                                    purchaseID: purchaseID
                                },
                                callBack: async (err, res) => {
                                    if (err) {
                                    }
                                }
                            }));
                        }
                    }
                }
            }));
        }
        else {
            showToast('Please connect telegram wallet!', "error");
            setLoading(false);
        }
    };

    const verifyPayment = async (purchaseID) => {
        try {
            const checkPayment = async (attempts = 0) => {
                if (attempts > 20) {
                    throw new Error('Timeout waiting for payment');
                }
                if (!purchaseID) {
                    throw new Error('No purchase ID provided');
                }
                try {
                    const res = await dispatch(checkPaymentStatus({ data: { purchaseID } })).unwrap();
                    if (res?.status === "success") {
                        setVerify(false);
                        showToast('Package Purchased Successfully!', 'success');
                        hidePopup();
                        dispatch(
                            getUserProfile({
                                data: {
                                    _id: userData?._id,
                                },
                                callBack: (err, res) => {
                                    if (err) return;
                                },
                            })
                        );
                        return;
                    }
                    else {
                        await new Promise(resolve => setTimeout(resolve, 5000));
                        return await checkPayment(attempts + 1);
                    }
                }
                catch (err) {
                    console.error("Error checking payment:", err);
                    setVerify(false);
                    setLoading(false);
                    hidePopup();
                    showToast('Package Payment timeout!', 'error');
                }
            };
            await checkPayment();
        }
        catch (error) {
            console.error('Verification error:', error);
            setVerify(false);
            setLoading(false);
            hidePopup();
            showToast('Package Payment timeout!', 'error');
        }
        finally {
            setLoading(false);
        }
    };

    const hidePopup = () => {
        setShowEnergyPackage(false);
    }

    return (
        <>
            {verify && (<VerifyingPaymentLoader />)}
            {loading && <CustomLoader />}
            <Modal
                show={showEnergyPackage}
                onHide={hidePopup}
                backdrop="true"
                centered
                scrollable="true"
                className={`${styles.EnergyShop} bottomPop`}
                keyboard={false}
            >
                <div className="modalWrpper">
                    <Modal.Body>
                        <Button
                            onClick={hidePopup}
                            variant="transparent"
                            className="border-0 p-0 position-absolute"
                            style={{ top: 15, right: 15 }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                                    fill="#506380"
                                />
                            </svg>
                        </Button>
                        <div style={{ maxWidth: 314 }} className="mx-auto">
                            <div className="top pb-3 text-center">
                                <h5 className="m-0 themeClr2 d-inline-block pb-1 fw-bold">
                                    Energy Shop
                                </h5>
                            </div>
                            <div className="py-2">
                                <div
                                    className={`${styles.box} shadow-sm position-relative mx-auto text-center rounded-4 p-3`}
                                // style={{ maxWidth: 290 }}
                                >
                                    <div className="">
                                        <div className="d-flex align-items-center gap-10">

                                            <div className="flex-shrink-0 position-relative text-start"
                                                style={{ width: "55%" }}>
                                                {packageItem?.isHotOffer &&
                                                    (
                                                        <div className={`${styles.hotOffer} position-absolute d-flex align-items-center px-2`} style={{ background: "#242AFC", top: -17, left: 0 }}>
                                                            <span className="icn me-1">{clockIcn}</span>
                                                            <p className="m-0 text-white">Hot offer</p>
                                                        </div>
                                                    )}
                                                <img src={packageItem?.logo} alt="" className="img-fluid" style={{ height: "100%", maxHeight: 102, marginTop: 10, marginBottom: 5 }} />
                                            </div>

                                            <div className="text-center d-flex align-items-center gap-10">
                                                <img src={p1} alt="" className="img-fluid flex-shrink-0" style={{ height: 28 }} />
                                                <h4 style={{ fontSize: 32 }} className="m-0 fw-bold text-white">{packageItem?.energy}<span className="" style={{ fontSize: 16 }}>X</span></h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="">
                                        <p className="m-0 fw-sbold text-white">
                                            Get {packageItem?.energy} energy & enjoy Bitanica Mines
                                        </p>
                                    </div>

                                </div>
                            </div>
                            <p className="text-center" style={{ color: "#EBF049" }}>USDT must be sent via TON chain. A small amount of TON is required for fees</p>
                            <div className="mt-3 text-center">
                                <Button
                                    style={{
                                        height: 48,
                                        width: "100%"
                                    }}
                                    onClick={() => { handlePurchase(packageItem?._id, packageItem?.energy) }}
                                    disabled={!packageItem}
                                    className={`${styles.submitBtn} d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0 mb-4`}
                                >
                                    {packageItem ? <>Buy for  <img src={tokenIcn} style={{ height: 20, width: 20 }} alt="" className="img-fluid flex-shrink-0 object-fit-contain mx-2" /> {packageItem.discountedPrice}</> : "Buy"}
                                </Button>
                            </div>

                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        </>
    );
};

export default EnergyShop;


const clockIcn = <svg width="9" height="9" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.22932 3.80942C6.22932 5.20066 5.10214 6.32978 3.71329 6.32978C2.32445 6.32978 1.19727 5.20066 1.19727 3.80942C1.19727 2.41818 2.32445 1.28906 3.71329 1.28906C5.10214 1.28906 6.22932 2.41818 6.22932 3.80942Z" stroke="white" strokeWidth="0.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.64763 4.61085L3.86766 4.14458C3.7318 4.06393 3.62109 3.86986 3.62109 3.71108V2.67773" stroke="white" strokeWidth="0.6" strokeLinecap="round" strokeLinejoin="round" />
</svg>
